var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#338AF3;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256c11.1,0,256-33.4,256-33.4L512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256C0,114.6,114.6,0,256,0s256,114.6,256,256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M357.6,176.6L256,278.3L154.4,176.6c-13.1,19.5-20.8,43-20.8,68.2v33.4c0,53.6,34.6,99.3,82.7,115.8 c-6.4,12.6-5.3,28.3,4.1,40c12.5-10,25.4-20.4,36.4-29.2c11,8.8,23.9,19.1,36.4,29.2c9.5-11.9,10.5-27.8,3.8-40.5 c47.4-16.9,81.5-62.2,81.5-115.4v-33.4C378.4,219.6,370.8,196.2,357.6,176.6L357.6,176.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,367.3c-49.1,0-89-39.9-89-89v-33.4c0-49.1,39.9-89,89-89s89,39.9,89,89v33.4 C345,327.4,305.1,367.3,256,367.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.7,278.3v-33.4c0-30.7-25-55.7-55.7-55.7s-55.7,25-55.7,55.7v33.4l55.7,11.1L311.7,278.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,278.3c0,30.7,25,55.7,55.7,55.7s55.7-25,55.7-55.7H200.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.8,155.8c0-18.4-15-33.4-33.4-33.4c-8.6,0-16.4,3.2-22.3,8.5v-19.6h11.1V89h-11.1V77.9h-22.3V89h-11.1v22.3 h11.1v19.6c-5.9-5.3-13.7-8.5-22.3-8.5c-18.4,0-33.4,14.9-33.4,33.4c0,9.9,4.3,18.8,11.1,24.9v19.6h111.3v-19.6 C318.5,174.6,322.8,165.7,322.8,155.8L322.8,155.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.103010b24b5cefa8a9491b755cec70bf.svg";
export { ForwardRef as ReactComponent };